module.exports = __webpack_public_path__ + "img/payment-systems.fb9d3b1f.webp";